export const startMessage = (streamId) => {
  return {
    type: 'screensharing:start',
    data: { streamId }
  }
}

export const stopMessage = () => {
  return {
    type: 'screensharing:stop',
    data: {}
  }
}
